import Table from '@/components/component/Reuse/Table/Table.vue'
import constants from '@/libs/constant/constants'
import {bulkUpdate, updateUserProfile} from '@/libs/api/api'

export default{
    name: 'DisplayTable',
    components: {
        Table, 
        AddNewCategory: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AddNewCategory/AddNewCategory.vue')
    },
    props: {
        category: {
            type: String
        },
        menuItem: {
            type: Object,
            required: true,
            default: () => {}
        },
        clickedOn: {
            type: String,
            required: true,
            default: ''
        },
        columns: {
            type: Array,
            default: () => []
        },
        tableOptions: {
            type: Object,
            default: () => {}
        },
        tableData: {
            type: Array,
            default: () => []
        },
        changePage: {
            type: Function,
            default: () => {}
        },
        changeRecord: {
            type: Function,
            default: () => {}
        },
        totaltableData: {
            type: Number,
        },
        currentPage: {
            type: Number,
            default: 1
        },
        selectedValue:{
            type:Number
        },
        sorting: {
            type: Function,
            default: () => {}
        },
        selectedTableFilters: {
            type: Object,
            default: () => {}
        },
        setTableFilters : {
            type: Function,
            default: () => {}
        },
        applyFilters: {
            type: Function,
            default: () => {}
        }
    },
    data () {
        return {
            totalPage: 0,
            current: 0,
            selected: 10,
            isAdd: false
        }
    },
    beforeMount() {
        this.$store.dispatch('setShowTableSettings', true)
        this.$store.dispatch('setContainer', false)
        this.$store.dispatch('setAddPublisher', false)
    },
    methods: {
        getIconClass (category) {
            switch (category) {
                case constants.ADMIN.Authors.value_without_s:
                    return 'nova-authorprofile icon'
                case constants.ADMIN.Publications.value_without_s:
                    return 'nova-publication icon'
                case constants.ADMIN.Publishers.value_without_s:
                    return 'nova-publisher icon'
            }
        },
        getHeader (category) {
            switch (category) {
                case constants.ADMIN.Authors.value_without_s:
                    return 'Authors'
                case constants.ADMIN.Publications.value_without_s:
                    return 'Publications'
                case constants.ADMIN.Publishers.value_without_s:
                    return 'Publishers'
                case constants.ADMIN.Users.value_without_s:
                    return 'Users'
                case constants.ADMIN.Articles.value_without_s:
                    return 'Articles'
            }
        },
        getCapitalName (category) {
            if (category !== '') {
                return `${category.charAt(0)}${category.slice(1).toLowerCase()}`
            }
            return ''
        },
        handleCommand (command, data) {
            let route = constants.GET_DATA[this.category].EDIT
            switch (command) {
                case 'EDIT':
                    this.$router.push({name: route, params: {id: data._id}})
                break
                case 'ADD':
                    if (this.category === 'USER') return
                    if (this.category === 'PUBLISHER') {
                        this.$store.dispatch('setAddPublisher', true)
                        this.$router.push({name: 'AddAdminPublisher'})
                    } else {
                        this.isAdd = true
                    }
                break
                case 'DELETE':
                    if (this.category === 'USER') return
                    if (this.category === 'ARTICLE') {
                        this.deleteTableRow('CONTENT', data)
                    } else {
                        this.deleteTableRow(this.category, data)
                    }
                break
                case 'SUSPEND':
                    this.suspendUser(data)
                break
            }
        },
        close() {
            this.isAdd = false
        },
        deleteTableRow (module, data) {
            let body = {
                entity_ids: [data._id],
                delete_from_ecosystem: true
            }
            bulkUpdate(module.toLowerCase(), body).then(() => {
                this.$emit('refreshPage')
            }).catch(error => {
                console.error(error)
            })
        },
        // to suspend/unsuspend user
        suspendUser (data) {
            let body = {
                suspended: data.suspended ? false : true,
                user_id: data._id
            }
            updateUserProfile(body).then(() => {
                this.$emit('refreshPage')
            }).catch(error => {
                console.error(error)
            })
        }
    }
}